"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _toConsumableArray2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menus = _interopRequireDefault(require("@/components/menus.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _courseTwo = _interopRequireDefault(require("@/components/courseTwo.vue"));
require("../index.less");
var _courseCard = _interopRequireDefault(require("@/components/courseCard/courseCard.vue"));
var _index2 = require("@/api/virtualSimulationClass/index");
var _projectLevel = require("@/utils/projectLevel");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseCard: _courseCard.default,
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default,
    Menus: _menus.default,
    CourseItem: _courseTwo.default
  },
  data: function data() {
    return {
      imgBanner: require("../../../assets/img/image/topbg.png"),
      menusList: [{
        tit: '产业分类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryType)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '行业门类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryCategory)),
        actheight: false,
        act: 0,
        isZhan: true
      }, {
        tit: '级别',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(_projectLevel.projectLevelOptions)),
        actheight: false,
        act: 0,
        isZhan: false
      }],
      query: {
        courseName: "",
        courseSource: "",
        pageNum: 1,
        pageSize: 20,
        projectLevel: "",
        provinceId: this.$store.getters.provinceId,
        courseType: '1',
        schoolId: '',
        showStatus: 1
      },
      list: [],
      total: 0,
      loading: false
    };
  },
  methods: {
    toSsearch: function toSsearch(e) {
      console.log('dianji', e);
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
      // this.query.industryDetail = e.majorId.charAt(0)
      this.getList();
    },
    chooseList: function chooseList(e) {
      console.log('dianji', e);
      if (e[0] == '产业分类') {
        if (e[1].name == '全部') {
          this.query.industry = '';
        } else {
          this.query.industry = e[1].name;
        }
      } else if (e[0] == '行业门类') {
        this.query.industryDetail = e[1].remark;
      } else if (e[0] == '级别') {
        if (e[1].name == '全部') {
          this.query.courseLevel = '';
        } else {
          this.query.courseLevel = e[1].name;
        }
      }
      this.query.pageNum = 1;
      this.getList();
    },
    // 获取课程
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _index2.getReceptionList)(this.query).then(function (res) {
        _this.list = res.rows;
        _this.total = res.total;
        _this.loading = false;
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query.pageSize = e;
      this.query.pageNum = 1;
      this.getList();
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getList();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};